const Actions = {
  Navigate: {
    DO: 'v.recovery-new.actions.navigate.do',
    CONTINUE: 'v.recovery-new.actions.navigate.continue',
    PREVIOUS: 'v.recovery-new.actions.navigate.previous'
  },

  Cancel: {
    DO: 'v.recovery-new.actions.cancel.do'
  },

  Form: {
    CHANGE: 'v.recovery-new.actions.form.change'
  },

  Steps: {
    Completed: {
      UPDATE: 'v.recovery-new.actions.steps.completed.update'
    },
    ActiveView: {
      SET: 'v.recovery-new.actions.steps.active-view.set'
    }
  }
};

const Mutations = {
  CLEAR: 'v.recovery-new.mutations.clear',
  INITIALIZE: 'v.recovery-new.mutations.initialize',

  ActiveView: {
    SET: 'v.recovery-new.mutations.active-view.set',
    CLEAR: 'v.recovery-new.mutations.active-view.clear'
  },

  Steps: {
    Completed: {
      SET: 'v.recovery-new.mutations.steps.completed.set'
    },
    Active: {
      SET: 'v.recovery-new.mutations.steps.active.set'
    },
    CLEAR: 'v.recovery-new.mutations.steps.clear'
  },

  Form: {
    CHANGE: 'v.recovery-new.mutations.form.change'
  },

  Validations: {
    CLEAR: 'v.recovery-new.mutations.validations.clear',
    SET_API: 'v.recovery-new.mutations.validations.set-api'
  }
};

const Views = {
  NewRecoveryInputForm: 'v.recovery-new.views.form',
  NewRecoveryConfirmation: 'v.recovery-new.views.confirmation'
};

export default {
  Actions,
  Mutations,
  Views
};
